import ActivityIcon from './activityIcon'
import PropTypes from 'prop-types'
import React, {Component} from 'react'
import flatMap from 'lodash/flatMap'
import uniqBy from 'lodash/uniqBy'
import {css} from 'glamor'

import Flyout from './flyout'
import Input from './input'
import ListGroup from './listGroup'
import {activityOrderBySchoolType} from '../constants/activities'
import {colors} from '../styles'

const style = {
  activityList: css({
    margin: '0 -1px'
  }),
  menuBody: css({
    padding: '0 20px 20px'
  }),
  menuHeader: css({
    border: 'none',
    padding: '15px 20px',
    textAlign: 'center'
  }),
  menuTitle: css({
    color: colors.grayMedium,
    fontSize: '14px',
    lineHeight: '16px',
    padding: '0 20px'
  }),
  menuActivity: css({
    margin: '4px 0 0',
    textTransform: 'none'
  }),
  speedDialList: css({
    display: 'flex',
    flexWrap: 'wrap',
    margin: '-10px',
    padding: 0
  }),
  speedDialListItem: css({
    border: `1px solid ${colors.gray77}`,
    borderRadius: '3px',
    color: colors.white,
    float: 'left',
    height: '80px',
    margin: '10px',
    width: '80px'
  }),
  speedDialListItemActive: css({
    border: `2px solid ${colors.primaryBG}`
  }),
  speedDialItemButton: css({
    background: 'none',
    border: 'none',
    height: '100%',
    margin: 0,
    padding: 0,
    width: '100%'
  })
}

export default class ActivityMenu extends Component {
  constructor(props) {
    super(props)

    this.state = {
      activityGroup: null,
      activityId: null,
      search: ''
    }
  }

  onChange = (tag) => {
    this.setState({activityId: null, search: ''}, () =>
      this.props.onChange(tag)
    )
  }

  onSearch = (e) => {
    this.setState({search: e.target.value})
  }

  setActivityGroup = (group) => {
    this.setState({
      activityGroup: group
    })
  }

  setActivityId = (id) => {
    this.setState({
      activityId: id
    })
  }

  setActivityMenuRef = (element) => {
    this.activityMenuRef = element
  }

  setMenuRef = (element) => {
    this.menuRef = element
  }

  onHide = (event) => {
    event.target.blur()
    const {onHide} = this.props

    this.setState({activityId: null}, () => {
      if (this.activityMenuRef) {
        this.activityMenuRef.scrollTop = 0
      }
      this.menuRef.scrollTop = 0
      onHide && onHide()
    })
  }

  render() {
    const {activities, schoolType, show, speedDialActivities, value} =
      this.props
    const {activityGroup, search} = this.state

    const searchResults = search
      ? uniqBy(
          flatMap(activities, (activity) =>
            activity.filter(
              ({Name}) => Name.toLowerCase().indexOf(search.toLowerCase()) > -1
            )
          ),
          'Tag'
        )
      : []

    const activityGroupOrder =
      activityOrderBySchoolType[schoolType] || activityOrderBySchoolType.default
    const activityList = activityGroupOrder
      .filter((activityGroupName) => activities[activityGroupName])
      .concat(
        Object.keys(activities).filter(
          (activityGroupName) => !activityGroupOrder.includes(activityGroupName)
        )
      )

    return (
      <Flyout from="right" show={show} onHide={this.onHide}>
        <nav className="menu" ref={this.setMenuRef}>
          <header {...style.menuHeader}>
            <div {...style.menuTitle}>Current Activity</div>
            <h4 {...style.menuActivity}>{value.Name}</h4>
          </header>
          <section {...style.menuBody}>
            <Input
              icon="search"
              label="Search Activities"
              onChange={this.onSearch}
              size="block"
              value={search}
            />
            {searchResults.length ? null : (
              <ul {...style.speedDialList}>
                {speedDialActivities.map((activity) => {
                  let speedDialItemStyle = style.speedDialListItem

                  if (activity.Tag === value.Tag) {
                    speedDialItemStyle = css(
                      speedDialItemStyle,
                      style.speedDialListItemActive
                    )
                  }

                  return (
                    <li key={activity.Tag} {...speedDialItemStyle}>
                      <button
                        onClick={() => this.onChange(activity.Tag)}
                        {...style.speedDialItemButton}
                      >
                        <ActivityIcon activity={activity} />
                      </button>
                    </li>
                  )
                })}
              </ul>
            )}
          </section>
          <section {...style.activityList}>
            {searchResults.length
              ? searchResults.map((activity) => (
                  <ListGroup.Item
                    key={activity.Tag}
                    onClick={() => this.onChange(activity.Tag)}
                  >
                    {activity.Name}
                  </ListGroup.Item>
                ))
              : activityList.map((activityGroup) => (
                  <ListGroup.Item
                    key={activityGroup}
                    onClick={() => this.setActivityGroup(activityGroup)}
                  >
                    {activityGroup}
                  </ListGroup.Item>
                ))}
          </section>
        </nav>
        <Flyout backdrop={false} from="right" show={!!activityGroup}>
          {activityGroup && (
            <nav className="activity-menu" ref={this.setActivityMenuRef}>
              <ListGroup.Heading onClick={() => this.setActivityGroup()}>
                {activityGroup}
              </ListGroup.Heading>
              {activities[activityGroup].map((activity) => (
                <ListGroup.Item
                  key={activity.Tag}
                  onClick={() => this.onChange(activity.Tag)}
                  radio
                  selected={activity.Tag === value.Tag}
                >
                  {activity.Name}
                </ListGroup.Item>
              ))}
            </nav>
          )}
        </Flyout>
      </Flyout>
    )
  }
}

ActivityMenu.propTypes = {
  activities: PropTypes.objectOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        Tag: PropTypes.string.isRequired,
        Name: PropTypes.string.isRequired
      })
    )
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  schoolType: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  speedDialActivities: PropTypes.arrayOf(
    PropTypes.shape({
      Tag: PropTypes.string.isRequired,
      Name: PropTypes.string.isRequired
    })
  ).isRequired,
  value: PropTypes.shape({
    Name: PropTypes.string.isRequired,
    Tag: PropTypes.string.isRequired
  }).isRequired
}
